/* Bauzaar · Vetrina brand (scheda prodotto) */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var configCache = {};
  var CACHE_MS = 10 * 60 * 1000;

  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function safeUrl(value) {
    var url = String(value || '').trim();
    return /^(https:\/\/|\/\/|\/(?!\/))/i.test(url) ? url : '';
  }
  function track(event, data) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: event }, data || {}));
  }

  /* ---------- Dati: categorie dalla pagina del quiz ---------- */
  function loadConfig(source, sectionId) {
    var key = 'v3|' + source;
    if (configCache[key]) return configCache[key];
    try {
      var stored = JSON.parse(sessionStorage.getItem('bzs:' + key) || 'null');
      if (stored && Date.now() - stored.t < CACHE_MS) {
        configCache[key] = Promise.resolve(stored.c);
        return configCache[key];
      }
    } catch (error) { /* sessionStorage non disponibile */ }
    /* Legge la pagina del quiz intera: l'ID della sezione nei template JSON cambia da tema a tema,
       mentre lo script con i dati e' sempre presente. */
    configCache[key] = fetch(source, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status + ' su ' + source);
        return response.text();
      })
      .then(function (html) {
        var match = html.match(/<script[^>]*data-bzd-config[^>]*>([\s\S]*?)<\/script>/i);
        if (!match) throw new Error('dati del quiz non trovati in ' + source);
        var data = { config: JSON.parse(match[1]), brands: [] };
        var brands = html.match(/<script[^>]*data-bzd-brands[^>]*>([\s\S]*?)<\/script>/i);
        if (brands) { try { data.brands = JSON.parse(brands[1]); } catch (error) { data.brands = []; } }
        try { sessionStorage.setItem('bzs:' + key, JSON.stringify({ t: Date.now(), c: data })); } catch (error) { /* pieno o bloccato */ }
        return data;
      })
      .catch(function (error) {
        delete configCache[key];
        throw error;
      });
    return configCache[key];
  }

  function speciesKey(raw) {
    var s = String(raw || '').toLowerCase();
    if (s.indexOf('cani') > -1 || s.indexOf('cane') > -1) return 'cane';
    if (s.indexOf('gatt') > -1) return 'gatto';
    if (s.indexOf('pesc') > -1) return 'pesci';
    if (s.indexOf('rettil') > -1) return 'rettili';
    if (s.indexOf('uccell') > -1) return 'uccelli';
    if (s.indexOf('conigl') > -1 || s.indexOf('rodit') > -1) return 'conigli-roditori';
    return '';
  }
  function otherMatches(list, key) {
    var values = String(list || '').toLowerCase().split(/[,\n]+/).map(function (v) { return v.trim(); });
    if (key === 'conigli-roditori') return values.indexOf('conigli') > -1 || values.indexOf('roditori') > -1 || values.indexOf('conigli-roditori') > -1;
    return values.indexOf(key) > -1;
  }
  function viewFor(format, key) {
    if (key === 'cane' || key === 'gatto') return format[key] || null;
    return format.other && otherMatches(format.otherSpecies, key) ? format.other : null;
  }
  function pickFormats(config, brand, species) {
    var all = (config && Array.isArray(config.formats) ? config.formats : []).filter(function (f) { return f && f.brand === brand; });
    var order = species ? [species] : [];
    ['cane', 'gatto', 'pesci', 'rettili', 'uccelli', 'conigli-roditori'].forEach(function (k) { if (order.indexOf(k) < 0) order.push(k); });
    for (var i = 0; i < order.length; i++) {
      var list = [];
      all.forEach(function (format) {
        var view = viewFor(format, order[i]);
        if (view && safeUrl(view.url)) list.push({ format: format, view: view });
      });
      if (list.length) return list;
    }
    return [];
  }
  function filterValues(url, name) {
    var out = [];
    try {
      new URL(url, window.location.origin).searchParams.forEach(function (value, key) {
        if (key === name) value.split(',').forEach(function (v) { if (v.trim()) out.push(v.trim().toLowerCase()); });
      });
    } catch (error) { /* url non valida */ }
    return out;
  }
  function startIndex(items, categoria, group) {
    var cat = String(categoria || '').trim().toLowerCase();
    var grp = String(group || '').trim().toLowerCase();
    for (var i = 0; i < items.length; i++) {
      var url = items[i].view.url;
      if (grp && filterValues(url, 'filter.p.m.custom.categoria_di_2_livello').indexOf(grp) > -1) return i;
      if (cat && filterValues(url, 'filter.p.m.custom.categoria').indexOf(cat) > -1) return i;
    }
    return 0;
  }

  /* ---------- USP con icone, come nella landing ---------- */
  var ICON_BASE = 'https://cdn.shopify.com/s/files/1/0961/7313/0053/files/';
  var ICONS = [
    [/prote|monoprot/i, 'icona_una_sola_proteina_monoproteico'],
    [/grain|cereal|gluten/i, 'icona_cereale_sbarrato_senza_cereali'],
    [/colorant|conservant|additiv|ogm|artificial/i, 'icona_provetta_sbarrata_senza_additivi'],
    [/natural|ingredient|fresc|ispirazion|barf/i, 'icona_pianta_con_foglie'],
    [/prezzo|convenien/i, 'icona_euro_scintillante'],
    [/vitamin|mineral|integrator|funzional|formul/i, 'icona_pillola'],
    [/italia/i, 'icona_mappa_italia_made_in_italy'],
    [/dental|dent|sorriso/i, 'icona_dente_scintillante_igiene_orale'],
    [/mastic|disidrat/i, 'icona_osso'],
    [/gioch|accessor|igiene|durevol/i, 'icona_palla_tennis'],
    [/tagli|et\u00e0|cuccioli|adulti|senior/i, 'icona_righello_taglia'],
    [/pesc|tartarug|acquar|uccelli|conigli|roditori/i, 'icona_casa_con_simbolo_cuore']
  ];
  function iconFor(text) {
    for (var i = 0; i < ICONS.length; i++) if (ICONS[i][0].test(text)) return ICON_BASE + ICONS[i][1] + '.png?width=96';
    return ICON_BASE + 'scudo_con_croce_medica.png?width=96';
  }
  var fitCache = {};
  function fitIcon(img) {
    var src = img.getAttribute('src');
    if (!fitCache[src]) {
      fitCache[src] = new Promise(function (resolve) {
        var probe = new Image();
        probe.crossOrigin = 'anonymous';
        probe.onload = function () {
          try {
            var w = probe.naturalWidth, h = probe.naturalHeight;
            if (!w || !h) return resolve(null);
            var canvas = document.createElement('canvas');
            canvas.width = w; canvas.height = h;
            var ctx = canvas.getContext('2d');
            ctx.drawImage(probe, 0, 0);
            var px = ctx.getImageData(0, 0, w, h).data, minX = w, minY = h, maxX = -1, maxY = -1;
            for (var y = 0; y < h; y++) for (var x = 0; x < w; x++) {
              if (px[4 * (y * w + x) + 3] > 24) { if (x < minX) minX = x; if (x > maxX) maxX = x; if (y < minY) minY = y; if (y > maxY) maxY = y; }
            }
            if (maxX < 0) return resolve(null);
            var unit = 1 / Math.max(w, h), ox = (1 - w * unit) / 2, oy = (1 - h * unit) / 2;
            var l = ox + minX * unit, r = ox + (maxX + 1) * unit, t = oy + minY * unit, b = oy + (maxY + 1) * unit;
            resolve({ cx: (l + r) / 2, cy: (t + b) / 2, size: Math.max(r - l, b - t) });
          } catch (error) { resolve(null); }
        };
        probe.onerror = function () { resolve(null); };
        probe.src = src;
      });
    }
    fitCache[src].then(function (box) {
      if (box && box.size > 0) {
        var scale = Math.max(0.85, Math.min(2.4, 0.94 / box.size));
        img.style.setProperty('--fs', scale.toFixed(3));
        img.style.setProperty('--fx', (-(box.cx - 0.5) * scale).toFixed(4));
        img.style.setProperty('--fy', (-(box.cy - 0.5) * scale).toFixed(4));
      }
      img.setAttribute('data-bzs-fitted', 'done');
    });
  }
  function fillUsps(root, brands) {
    var list = root.querySelector('[data-bzs-usps]');
    if (!list || !Array.isArray(brands)) return;
    var id = root.getAttribute('data-brand');
    var brand = brands.filter(function (b) { return b && b.id === id; })[0];
    var lines = brand ? String(brand.usp || '').split(/\r?\n/).map(function (v) { return v.trim(); }).filter(Boolean).slice(0, 3) : [];
    if (!lines.length) return;
    list.innerHTML = lines.map(function (line) {
      return '<li><span class="bzs-usp-icon" aria-hidden="true"><img src="' + esc(iconFor(line)) + '" alt="" width="30" height="30" loading="lazy" decoding="async" data-bzs-fit></span><span>' + esc(line) + '</span></li>';
    }).join('');
    list.hidden = false;
    list.querySelectorAll('img[data-bzs-fit]').forEach(fitIcon);
  }

  /* ---------- Molla: smorzamento + risposta, sempre interrompibile ---------- */
  function Spring(onUpdate) {
    this.x = 0; this.v = 0; this.target = 0; this.raf = 0; this.last = 0;
    this.onUpdate = onUpdate;
    this.configure(0.42, 1);
  }
  Spring.prototype.configure = function (response, damping) {
    var omega = (2 * Math.PI) / response;
    this.k = omega * omega;
    this.c = 2 * damping * omega;
  };
  Spring.prototype.set = function (x) {
    this.stop();
    this.x = this.target = x;
    this.v = 0;
    this.onUpdate(x);
  };
  Spring.prototype.stop = function () {
    if (this.raf) cancelAnimationFrame(this.raf);
    this.raf = 0;
  };
  Spring.prototype.to = function (target, velocity) {
    this.target = target;
    if (typeof velocity === 'number') this.v = velocity;
    if (reduceMotion) { this.set(target); return; }
    if (this.raf) return;
    var self = this;
    this.last = 0;
    var step = function (now) {
      if (!self.last) self.last = now;
      var dt = Math.min(0.034, (now - self.last) / 1000);
      self.last = now;
      var h = 1 / 240;
      for (var t = 0; t < dt; t += h) {
        var a = -self.k * (self.x - self.target) - self.c * self.v;
        self.v += a * h;
        self.x += self.v * h;
      }
      if (Math.abs(self.x - self.target) < 0.25 && Math.abs(self.v) < 8) {
        self.x = self.target; self.v = 0; self.raf = 0;
        self.onUpdate(self.x);
        return;
      }
      self.onUpdate(self.x);
      self.raf = requestAnimationFrame(step);
    };
    this.raf = requestAnimationFrame(step);
  };

  function rubberband(overshoot, dimension) {
    var c = 0.55;
    return (overshoot * dimension * c) / (dimension + c * Math.abs(overshoot));
  }
  function project(velocity) {
    var d = 0.998;
    return (velocity / 1000) * d / (1 - d);
  }

  var ARROW_PREV = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>';
  var ARROW_NEXT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>';

  /* ---------- Carosello ---------- */
  function buildStage(root, stage, items, config, first) {
    var brandName = root.getAttribute('data-brand-name') || '';
    var cta = (config.texts && config.texts.categoryCta) || 'Esplora la categoria';
    var many = items.length > 1;
    var slidesHtml = items.map(function (item, i) {
      var v = item.view;
      var img = safeUrl(v.composition) || safeUrl((v.products || [])[0]) || safeUrl(v.image);
      return '<div class="bzs-slide" role="group" aria-roledescription="slide" aria-label="' + (i + 1) + ' di ' + items.length + ': ' + esc(item.format.label) + '" style="--slide-bg:' + esc(item.format.color || '#eef4f6') + '" data-index="' + i + '">' +
        (img ? '<figure class="bzs-visual"><img src="' + esc(img) + '" alt="' + esc((v.title || item.format.label) + ' ' + brandName) + '" loading="lazy" decoding="async" draggable="false"></figure>' : '<div class="bzs-visual"></div>') +
        '<h3 class="bzs-slide__title">' + esc(v.title || item.format.label) + '</h3>' +
        (v.description ? '<p class="bzs-slide__text">' + esc(v.description) + '</p>' : '') +
        '<a class="bzs-cta" href="' + esc(safeUrl(v.url)) + '" data-bzs-track="category">' + esc(cta) + '</a>' +
      '</div>';
    }).join('');

    stage.innerHTML =
      (many ? '<div class="bzs-controls"><div class="bzs-pills" role="group" aria-label="Categorie ' + esc(brandName) + '">' +
        items.map(function (item, i) { return '<button type="button" class="bzs-pill" data-go="' + i + '" aria-pressed="false">' + esc(item.format.label) + '</button>'; }).join('') +
        '</div></div>' +
        '<button type="button" class="bzs-arrow bzs-arrow--prev" data-dir="-1" aria-label="Categoria precedente">' + ARROW_PREV + '</button>' +
        '<button type="button" class="bzs-arrow bzs-arrow--next" data-dir="1" aria-label="Categoria successiva">' + ARROW_NEXT + '</button>' : '') +
      '<div class="bzs-viewport" role="region" aria-roledescription="carousel" aria-label="Categorie ' + esc(brandName) + '">' +
        '<div class="bzs-track">' + slidesHtml + '</div>' +
      '</div><p class="bzs-status" aria-live="polite"></p>';
    stage.classList.remove('is-loading');
    stage.removeAttribute('aria-busy');

    var viewport = stage.querySelector('.bzs-viewport');
    var trackEl = stage.querySelector('.bzs-track');
    var slides = Array.prototype.slice.call(stage.querySelectorAll('.bzs-slide'));
    var pills = Array.prototype.slice.call(stage.querySelectorAll('.bzs-pill'));
    var pillBar = stage.querySelector('.bzs-pills');
    var prev = stage.querySelector('.bzs-arrow--prev');
    var next = stage.querySelector('.bzs-arrow--next');
    var status = stage.querySelector('.bzs-status');
    var brand = root.getAttribute('data-brand');
    var index = first;
    var stepPx = 0;
    var offset = 0;

    var spring = new Spring(function (x) { trackEl.style.transform = 'translate3d(' + x.toFixed(2) + 'px,0,0)'; });

    function measure() {
      stepPx = slides.length > 1 ? slides[1].offsetLeft - slides[0].offsetLeft : viewport.clientWidth;
      if (!stepPx) stepPx = viewport.clientWidth || 1;
      offset = Math.max(0, (viewport.clientWidth - slides[0].offsetWidth) / 2);
    }
    function posOf(i) { return offset - i * stepPx; }
    function bounds() { return { min: posOf(slides.length - 1), max: posOf(0) }; }

    function syncUi(announce) {
      pills.forEach(function (pill, i) { pill.setAttribute('aria-pressed', String(i === index)); });
      slides.forEach(function (slide, i) {
        var active = i === index;
        slide.classList.toggle('is-active', active);
        var link = slide.querySelector('.bzs-cta');
        if (link) link.tabIndex = active ? 0 : -1;
      });
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index === slides.length - 1;
      var pill = pills[index];
      if (pill && pillBar && pillBar.scrollWidth > pillBar.clientWidth) {
        var left = pill.offsetLeft - (pillBar.clientWidth - pill.offsetWidth) / 2;
        pillBar.scrollTo({ left: Math.max(0, left), behavior: reduceMotion ? 'auto' : 'smooth' });
      }
      if (announce) status.textContent = items[index].format.label;
    }
    function goTo(i, velocity, method) {
      var target = Math.max(0, Math.min(slides.length - 1, i));
      var changed = target !== index;
      index = target;
      if (typeof velocity === 'number' && Math.abs(velocity) > 400) spring.configure(0.38, 0.86);
      else spring.configure(0.42, 1);
      spring.to(posOf(index), typeof velocity === 'number' ? velocity : undefined);
      syncUi(changed);
      if (changed && method) track('bzs_category', { bzs_brand: brand, bzs_category: items[index].format.label, bzs_method: method });
    }

    measure();
    spring.set(posOf(index));
    syncUi(false);

    stage.addEventListener('click', function (event) {
      var pill = event.target.closest('[data-go]');
      if (pill) { goTo(Number(pill.getAttribute('data-go')), undefined, 'pill'); return; }
      var arrow = event.target.closest('[data-dir]');
      if (arrow) { goTo(index + Number(arrow.getAttribute('data-dir')), undefined, 'arrow'); return; }
    });

    /* Trascinamento 1:1 con rubber-band e slancio */
    var drag = null;
    var suppressClick = false;
    viewport.addEventListener('pointerdown', function (event) {
      if (slides.length < 2 || (event.pointerType === 'mouse' && event.button !== 0)) return;
      spring.stop();
      drag = { id: event.pointerId, x0: event.clientX, y0: event.clientY, start: spring.x, pos: spring.x, from: index, mode: '', samples: [{ t: event.timeStamp, x: event.clientX }] };
    });
    viewport.addEventListener('pointermove', function (event) {
      if (!drag || event.pointerId !== drag.id) return;
      var dx = event.clientX - drag.x0;
      var dy = event.clientY - drag.y0;
      if (!drag.mode) {
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
        drag.mode = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        if (drag.mode === 'y') { drag = null; spring.to(posOf(index)); return; }
        viewport.setPointerCapture(event.pointerId);
        viewport.classList.add('is-dragging');
      }
      var b = bounds();
      var raw = drag.start + dx;
      var pos = raw;
      if (raw > b.max) pos = b.max + rubberband(raw - b.max, viewport.clientWidth);
      else if (raw < b.min) pos = b.min + rubberband(raw - b.min, viewport.clientWidth);
      drag.pos = pos;
      spring.x = pos; spring.v = 0; spring.target = pos;
      spring.onUpdate(pos);
      drag.samples.push({ t: event.timeStamp, x: event.clientX });
      while (drag.samples.length > 2 && event.timeStamp - drag.samples[0].t > 100) drag.samples.shift();
    });
    function endDrag(event, cancelled) {
      if (!drag || event.pointerId !== drag.id) return;
      var current = drag;
      drag = null;
      viewport.classList.remove('is-dragging');
      if (current.mode !== 'x') return;
      suppressClick = true;
      window.setTimeout(function () { suppressClick = false; }, 60);
      var first = current.samples[0];
      var last = current.samples[current.samples.length - 1];
      var dt = Math.max(1, last.t - first.t);
      var velocity = cancelled ? 0 : ((last.x - first.x) / dt) * 1000;
      spring.x = current.pos;
      spring.v = velocity;
      var projected = current.pos + project(velocity);
      var target = Math.round((offset - projected) / stepPx);
      target = Math.max(current.from - 1, Math.min(current.from + 1, target));
      goTo(target, velocity, 'swipe');
    }
    viewport.addEventListener('pointerup', function (event) { endDrag(event, false); });
    viewport.addEventListener('pointercancel', function (event) { endDrag(event, true); });
    viewport.addEventListener('click', function (event) {
      if (suppressClick) { event.preventDefault(); event.stopPropagation(); return; }
      var slide = event.target.closest('.bzs-slide');
      if (slide && Number(slide.getAttribute('data-index')) !== index) {
        event.preventDefault();
        goTo(Number(slide.getAttribute('data-index')), undefined, 'tap');
        return;
      }
      var link = event.target.closest('[data-bzs-track]');
      if (link) track('bzs_click', { bzs_brand: brand, bzs_target: 'category', bzs_category: items[index].format.label });
    }, true);
    viewport.addEventListener('dragstart', function (event) { event.preventDefault(); });

    root.addEventListener('keydown', function (event) {
      if (!stage.contains(event.target) || slides.length < 2) return;
      if (event.key === 'ArrowLeft') { event.preventDefault(); goTo(index - 1, undefined, 'keyboard'); }
      if (event.key === 'ArrowRight') { event.preventDefault(); goTo(index + 1, undefined, 'keyboard'); }
    });

    var resizeTimer = 0;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () { measure(); spring.set(posOf(index)); }, 80);
    }, { passive: true });
  }

  /* ---------- Racconto: leggi di piu' su mobile ---------- */
  function setupMore(root) {
    var story = root.querySelector('[data-bzs-story]');
    var button = root.querySelector('[data-bzs-more]');
    if (!story || !button) return;
    var quote = story.querySelector('.bzs-quote');
    var hasMore = !!story.querySelector('.bzs-usp') || (quote && quote.scrollHeight > quote.clientHeight + 2);
    if (!hasMore) { button.hidden = true; return; }
    button.addEventListener('click', function () {
      var open = !story.classList.contains('is-open');
      story.classList.toggle('is-open', open);
      button.setAttribute('aria-expanded', String(open));
      button.textContent = open ? button.getAttribute('data-less') : button.getAttribute('data-more');
    });
  }

  /* ---------- Link "Scopri il brand" accanto alla riga Brand: della scheda ---------- */
  var JUMP_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';
  function addJumpLink(root) {
    if (!root.id) return;
    var label = root.getAttribute('data-jump') || 'Scopri il brand';
    var found = 0;
    document.querySelectorAll('a[href*="/collections/"]').forEach(function (link) {
      if (root.contains(link) || link.closest('header, footer, nav, .bzs')) return;
      var host = link.parentElement;
      for (var depth = 0; host && depth < 3; depth++, host = host.parentElement) {
        var text = (host.textContent || '').replace(/\s+/g, ' ').trim();
        if (/^brand\s*:/i.test(text) && text.length < 120) break;
      }
      if (!host || depth >= 3 || host.querySelector('.bzs-jump')) return;
      var jump = document.createElement('a');
      jump.className = 'bzs-jump';
      jump.href = '#' + root.id;
      jump.innerHTML = '<span>' + esc(label) + '</span>' + JUMP_ICON;
      jump.addEventListener('click', function (event) {
        event.preventDefault();
        root.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        track('bzs_click', { bzs_brand: root.getAttribute('data-brand'), bzs_target: 'jump' });
      });
      link.insertAdjacentElement('afterend', jump);
      found++;
    });
    if (!found) console.info('[Vetrina brand] Riga "Brand:" non trovata nella scheda: link Scopri il brand non aggiunto.');
  }

  function solo(root, stage) {
    stage.classList.add('is-hidden');
    var grid = root.querySelector('[data-bzs-grid]');
    if (grid) grid.classList.add('is-solo');
  }

  function mount(root) {
    if (!root || root.getAttribute('data-bzs-ready') === 'true') return;
    root.setAttribute('data-bzs-ready', 'true');
    setupMore(root);
    addJumpLink(root);
    var stage = root.querySelector('[data-bzs-stage]');
    if (!stage) return;
    var brandLink = root.querySelector('.bzs-brandlink');
    if (brandLink) brandLink.addEventListener('click', function () { track('bzs_click', { bzs_brand: root.getAttribute('data-brand'), bzs_target: 'brand' }); });

    var started = false;
    function start() {
      if (started) return;
      started = true;
      loadConfig(root.getAttribute('data-source') || '/pages/brand-esclusivi', root.getAttribute('data-section') || 'main')
        .then(function (data) {
          var config = data.config;
          fillUsps(root, data.brands);
          var items = pickFormats(config, root.getAttribute('data-brand'), speciesKey(root.getAttribute('data-species')));
          if (!items.length) { console.warn('[Vetrina brand] Nessuna categoria per il brand "' + root.getAttribute('data-brand') + '" con specie "' + root.getAttribute('data-species') + '"'); solo(root, stage); return; }
          buildStage(root, stage, items, config, startIndex(items, root.getAttribute('data-categoria'), root.getAttribute('data-group')));
          track('bzs_view', { bzs_brand: root.getAttribute('data-brand'), bzs_product: root.getAttribute('data-product') });
        })
        .catch(function (error) { console.warn('[Vetrina brand] Carosello non caricato:', error && error.message); solo(root, stage); });
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) { io.disconnect(); start(); }
      }, { rootMargin: '600px 0px' });
      io.observe(root);
    } else {
      start();
    }
  }

  function init() {
    document.querySelectorAll('[data-bzd-showcase]').forEach(mount);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector && event.target.querySelector('[data-bzd-showcase]');
    if (root) mount(root);
  });
})();
